
import GwCookieBar from '~/patterns/organisms/cookie-bar/cookie-bar.vue';

export default {
    components: {
        GwCookieBar
    }
};
